const id_template = {
    best_regards: "hormat kami",
    dear: "Kepada Yth,",
    delivered_to: "ditujukan kepada",
    send_by: 'dikirim oleh',

    no_so: "nomor sales order",
    no_do: "nomor delivery order",

    // note
    note_inv_1: "MAKE ALL CHECKS PAYABLE TO",
    note_itemin: "Catatan Barang Masuk",

    receipt: "tanda terima",
    receipt_by_fix: "Yang Menerima,",
    receipt_from: "Tanda Terima dari",
    received_by: "diterima oleh",
    spelled_out: "terbilang",
    user_input: "input pengguna",

    term_condition: "Syarat dan Ketentuan",

    // warehouse
    whs_for: "untuk gudang",
    whs_storage: "gudang penyimpanan",
    whs_admin: "Admin Gudang",
    whs_head: "Kepala Gudang",
    whs_tim: "Tim Gudang",

    // recap
    recap_inv_count: "Berupa Invoice Sebanyak",
    recap_inv_total: "Jumlah Tagihan",
    recap_detail: "Dengan Perincian",

    // planning
    planning_no: "Nomor Rencana",
    planning_date: "Tanggal Rencana",
    planning_name: "Nama Rencana",
    planning_price_ref: "Referensi Harga",
    planning_qty: "Max Kuantitas",

    // invoice
    invoice_in: {
        title: "catatan invoice / faktur pembelian",
    },
}

export default id_template;